import { Component, EventEmitter, Input, Output } from '@angular/core';
import { formatSigned } from './transaction-row.util';

/**
 * The bar under the ledger while rows are ticked: how many, their net, and what can be done
 * with them. Shared by the Transactions screen (add to a report) and a report's coding view
 * (remove from it) -- SD-1227. Which actions show is the host's call.
 */
@Component({
  selector: 'app-transactions-selection-bar',
  templateUrl: './transactions-selection-bar.component.html',
  styleUrls: ['./transactions-selection-bar.component.scss']
})
export class TransactionsSelectionBarComponent {
  @Input() count = 0;
  @Input() total = 0;
  /** The ticked rows that are not reconciled already, which is what coding applies to. */
  @Input() codeableCount = 0;

  @Input() showCode = true;
  @Input() showAddToReport = false;
  @Input() showRemoveFromReport = false;
  /** "Assign to": the Transactions screen offers it to everyone but a Submitter. */
  @Input() showAssign = false;
  /** A request from this bar is in flight. */
  @Input() busy = false;
  /** "Suggest coding": offered only while the organisation's Coding Assistant is on. */
  @Input() showSuggestCoding = false;
  /** The Coding Assistant is working on the selection. */
  @Input() suggesting = false;

  @Output() clear = new EventEmitter<void>();
  @Output() code = new EventEmitter<void>();
  @Output() addToReport = new EventEmitter<void>();
  @Output() removeFromReport = new EventEmitter<void>();
  @Output() assign = new EventEmitter<void>();
  @Output() suggestCoding = new EventEmitter<void>();

  signed(value: number): string {
    return formatSigned(value);
  }
}
